"use client";

import { useClientRuntime } from "./use-client-runtime";

const defineInteractive = () =>
  import("@tripcart/page-builder/web-components").then((m) =>
    m.defineInteractive(window),
  );

/**
 * Loads and registers the interactive web components (`<tc-tabs>`) on a
 * published page, where the content is React-rendered.
 *
 * Why a client-only dynamic import, not a `<script>` tag or a static import:
 *   - The web-component module builds `class extends HTMLElement` when it
 *     runs, which throws in Node — so it must never run during SSR. A dynamic
 *     `import()` inside `useEffect` only executes in the browser.
 *   - `useEffect` runs after THIS component hydrates — which does NOT mean
 *     after the whole page has. Once the elements are defined (a back
 *     navigation, for one), they can adopt markup React has not hydrated yet,
 *     and an attribute the runtime then writes reads to React as a mismatch.
 *     The carousel's arrows are one: authored `disabled`, enabled by the
 *     runtime. Nothing suppresses that warning today — the arrows are stored
 *     components rendered by `render-component.tsx`, which sets no
 *     `suppressHydrationWarning` on any element.
 *   - `defineInteractive` builds the classes against THIS window's
 *     HTMLElement. The editor canvas calls the same function with the iframe's
 *     window, so one source serves both realms with no build step.
 *
 * Rendered only when the page actually uses an interactive component (see
 * `usesInteractiveComponents`), so pages without one ship no web-component JS.
 */
export function InteractiveComponentsLoader() {
  useClientRuntime(defineInteractive);
  return null;
}
